import React from 'react';
import styled from 'styled-components';
import { CONTENT_MAX_WIDTH_PX } from '@constants';
import { PageSlice, SliceBannerGridDetails, SliceBannerGridItem } from '@contracts';
import Colors from '../Colors';
import BannerGridItem from './BannerGridItem';

interface GridProps {
  slice: PageSlice;
}

const BannerGrid: React.FC<GridProps> = ({ slice }) => {
  const sliceDetails = slice.primary as SliceBannerGridDetails;
  const sliceItems = slice.items as SliceBannerGridItem[];

  return (
    <GridContainer $background={sliceDetails?.background_text}>
      <Wrapper>
        <Grid>
          {sliceItems.map((item, index) => (
            <BannerGridItem key={index} item={item} />
          ))}
        </Grid>
      </Wrapper>
    </GridContainer>
  );
};

export default BannerGrid;

const GridContainer = styled.section<{ $background?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${(props) => props.$background || 'transparent'};
  color: ${Colors.navyBlue};
`;

const Wrapper = styled.div`
  width: 90vw;
  max-width: ${CONTENT_MAX_WIDTH_PX};
  margin: 0 auto;
  padding: 96px 0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 56px 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 32px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 24px;
    grid-template-columns: 100%;
  }
`;
